import MenuItem from "@mui/material/MenuItem";
import { ComponentProps } from "react";
import { useTranslation } from "react-i18next";

interface Props extends ComponentProps<typeof MenuItem> {
  onExport: () => void;
  disabled?: boolean;
  /** Passed in by the grid's export menu so the item can close it. */
  hideMenu?: () => void;
}

/**
 * An Excel export that a page builds itself.
 *
 * For pages whose sheet is a report rather than a dump of the grid — it records what was queried
 * above the table, which the grid's own export cannot know about. Sits next to the built-in export
 * items and reads the same, so a user does not have to know which kind a page offers.
 */
export default function MetadataExcelExportMenuItem({
  onExport,
  disabled,
  hideMenu,
  ...other
}: Props) {
  const { t } = useTranslation();

  return (
    <MenuItem
      // Forwarded, because the export menu clones focus handling onto its children and an item
      // that drops it is skipped when the menu is driven from the keyboard.
      {...other}
      disabled={disabled}
      onClick={() => {
        onExport();
        hideMenu?.();
      }}
    >
      {t("common.downloadAsExcel", "Download als Excel")}
    </MenuItem>
  );
}
